module.exports = __webpack_public_path__ + "media/images/icons/icn_006-6d5b8102c8165326931d78d55f4d049c.svg";